// Lucide icon: house (https://lucide.dev/icons/house)
import { House } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconDashboard = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <House />
    </IconComponentStyled>
  )
}
